export const METIERS = [
  "Plombier",
  "Climaticien",
  "Frigoriste",
  "Chauffagiste",
  "Électricien",
  "Technicien de maintenance",
  "Installateur PAC",
  "Installateur",
  "Artisan du bâtiment",
  "Autre",
];

export const REGIONS = [
  "Auvergne-Rhône-Alpes",
  "Bourgogne-Franche-Comté",
  "Bretagne",
  "Centre-Val de Loire",
  "Corse",
  "Grand Est",
  "Hauts-de-France",
  "Île-de-France",
  "Normandie",
  "Nouvelle-Aquitaine",
  "Occitanie",
  "Pays de la Loire",
  "Provence-Alpes-Côte d'Azur",
  "Outre-mer",
];

export const NB_BOX_OPTIONS = ["1", "2", "3", "4+", "Je ne sais pas encore"];

export const NB_BOX_PRICE_OPTIONS = ["1", "2", "3", "4", "5", "Plus de 5"];

export const VEHICULES_OPTIONS = ["1", "2", "3", "4+"];

export const INTERETS_OPTIONS = [
  "Gagner du temps",
  "Éviter les ruptures de stock",
  "Mieux gérer le stock du véhicule",
  "Connaître rapidement les quantités restantes",
  "Automatiser le suivi",
  "Recevoir des alertes",
  "Mieux organiser mes consommables",
  "Autre",
];

export const OUI_PEUTETRE_NON = [
  { value: "oui", label: "Oui" },
  { value: "peut_etre", label: "Peut-être" },
  { value: "non", label: "Non" },
];

export const REACTIONS_PRIX = [
  { value: "acheterait_probablement", label: "Je l'achèterais probablement" },
  { value: "pourrait_acheter", label: "Je pourrais l'acheter" },
  { value: "plus_infos", label: "Je demanderais plus d'informations avant de décider" },
  { value: "non", label: "Je ne l'achèterais probablement pas" },
];

export const REACTION_LABELS = Object.fromEntries(REACTIONS_PRIX.map((r) => [r.value, r.label]));

export const INTENTION_LANCEMENT = [
  { value: "oui", label: "Oui, je veux être parmi les premiers informés" },
  { value: "peut_etre", label: "Peut-être, je souhaite suivre le projet" },
  { value: "non", label: "Non merci" },
];

export const PRICE_QUESTIONS = [
  {
    key: "prix_trop_bas",
    label: "À partir de quel prix trouveriez-vous STOCKBOX 8 tellement peu chère que vous douteriez de sa qualité ?",
  },
  {
    key: "prix_bonne_affaire",
    label: "À quel prix considéreriez-vous STOCKBOX 8 comme une très bonne affaire ?",
  },
  {
    key: "prix_cher_acceptable",
    label: "À partir de quel prix commenceriez-vous à trouver STOCKBOX 8 chère, mais pourriez-vous encore envisager de l'acheter ?",
  },
  {
    key: "prix_trop_cher",
    label: "À partir de quel prix trouveriez-vous STOCKBOX 8 trop chère et renonceriez-vous à l'acheter ?",
  },
];

export const PRICE_QUESTION_LABELS = {
  prix_trop_bas: "Trop peu cher (qualité douteuse)",
  prix_bonne_affaire: "Très bonne affaire",
  prix_cher_acceptable: "Cher mais acceptable",
  prix_trop_cher: "Trop cher (renonce)",
};
